// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3K7aE","info":"Note_info__3k-ED","note":"Note_note__1f8qC","actions":"Note_actions__DaBVe"};